export default __webpack_public_path__ + "static/media/select.ad473691.svg";